import { render, staticRenderFns } from "./avatar.vue?vue&type=template&id=bcecfcc0&scoped=true&lang=pug&"
import script from "./avatar.vue?vue&type=script&lang=js&"
export * from "./avatar.vue?vue&type=script&lang=js&"
import style0 from "./avatar.vue?vue&type=style&index=0&id=bcecfcc0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcecfcc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('bcecfcc0', component.options)
    } else {
      api.reload('bcecfcc0', component.options)
    }
    module.hot.accept("./avatar.vue?vue&type=template&id=bcecfcc0&scoped=true&lang=pug&", function () {
      api.rerender('bcecfcc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/User/thumbnail/avatar.vue"
export default component.exports